import { http, uploadFile } from '@/utils/axios'
import qs from 'qs'


/**
 * @msg: 获取小组列表
 */
export function getGroupList ({ page = 0, pageSize = 10, courseId = '', infoType = '1'}) {
  return http({
    url: http.baseUrl('notice/getGroupList'),
    method: 'get',
    params: http.params({
      page,
      pageSize,
      courseId,
      infoType
    })
  })
}
/**
 * @msg: 公告详情
 */
export function getNotice ({ id=''}) {
  return http({
    url: http.baseUrl('notice/getNotice'),
    method: 'get',
    params: http.params({
      id
    })
  })
}
/**
 * @msg: 获取公告文件
 */
export function getFile (data) {
  return http({
    url: http.baseUrl('notice/getFile'),
    method: 'get',
    params: http.params(data),
    responseType: 'blob'
  })
}
/**
 * @msg: 获取公告文件名
 */
export function getFileName (data) {
  return http({
    url: http.baseUrl('notice/getFileName'),
    method: 'get',
    params: http.params(data),
  })
}
/**
 * @msg: 修改公告
 */
export function editNotice (data,filedata) {
  //文件上传
  let formData = new FormData();
  formData.append('file',filedata);
  return http({
    url: http.baseUrl('notice/saveOrUpdate'),
    method: 'post',
    params: http.params(data),
    data:formData
  })
  // return uploadFile({
  //   url: http.baseUrl('notice/saveOrUpdate'),
  //   data: data
  //   // data:http.data({
  //   //   data
  //   // })
  // })
}



/**
 * @msg: 获取新增下载文件
 */
export function getFile2 (data) {
  return http({
    url: http.baseUrl('notice/getFiles'),
    method: 'post',
    params: http.params(data),
    data:data
  })
}
